import { Box } from '@spark-web/box';
import { Button } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { HomeIcon, InformationCircleIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { LABELS } from '@utils';
import EligibilityStepHeader from './EligibilityStepHeader';

type ConfirmInstallationAddressProps = {
  address: string;
  productName: string;
  vendorName: string;
  onConfirm: () => void;
  onBack: () => void;
};

function ConfirmInstallationAddress({
  address,
  productName,
  vendorName,
  onConfirm,
  onBack,
}: ConfirmInstallationAddressProps) {
  return (
    <Stack padding="xlarge" gap="xlarge">
      <EligibilityStepHeader currentStep={2} totalSteps={5} productName={productName} />

      <Stack gap="xxlarge">
        <Heading level="1">Confirm your installation address</Heading>

        <Text size="standard">
          Let&apos;s start by confirming the installation address. This is the address provided by{' '}
          <Text as="span" weight="semibold" inline>
            {vendorName}
          </Text>
          .
        </Text>

        <Box
          display="flex"
          alignItems="start"
          gap="medium"
          padding="large"
          borderRadius="medium"
          background="surfaceMuted"
          borderWidth="standard"
          border="standard"
        >
          <Box flexShrink={0} paddingTop="xsmall">
            <HomeIcon size="small" tone="primary" />
          </Box>
          <Stack gap="small">
            <Text weight="semibold" size="standard">
              Installation address
            </Text>
            {address ? (
              <Text size="standard">{address}</Text>
            ) : (
              <Text size="standard" tone="muted">
                Address not available
              </Text>
            )}
          </Stack>
        </Box>
        <Box
          display="flex"
          alignItems="start"
          gap="medium"
          padding="large"
          borderRadius="medium"
          background="infoMuted"
        >
          <Box flexShrink={0} paddingTop="xsmall">
            <InformationCircleIcon size="small" tone="info" />
          </Box>
          <Text size="small">
            By continuing, you consent to Brighte running a check to establish who owns the property. Only the owner of
            the property can apply for the loan.
          </Text>
        </Box>
      </Stack>

      <Stack gap="xxlarge">
        <Button onClick={onConfirm} tone="primary">
          {LABELS.CONTINUE}
        </Button>
        <Box alignSelf="start">
          <Button prominence="none" tone="neutral" onClick={onBack}>
            ← Back
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
}

export default ConfirmInstallationAddress;
